































import {
  defineComponent, ref, useContext
} from '@nuxtjs/composition-api';
import {usePageStore} from "~/stores/page";
import CategoryPageContent from "~/components/Palmers/Category/CategoryPageContent.vue";
import usePalmersCategory from "~/composables/Palmers/Category/usePalmersCategory";
import { getMetaInfoVuePages } from '~/helpers/getMetaInfo';

export default defineComponent({
  name: 'Search',
  components: {
    CategoryPageContent
  },
  transition: 'fade',
  setup() {
    const update = ref(1);
    const pageStore = usePageStore();
    const context = useContext();

    const term = ref(context.params.value.term);
    const searchResults = ref(context.params.value.searchResults);

    pageStore.$patch((state) => {
      state.routeData = {
        type: 'SUB_CATEGORY',
        __typename: 'CategoryTree'
      };
    });

    const {
      isPriceLoaded,
      uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      pagination,
      products,
      sortBy,
      cmsContent,
      activeCategoryName,
      routeData,
      doChangeItemsPerPage,
      onReloadProducts,
      goToPage,
      categoryPageContent,
      isInWishlist,
      isAuthenticated,
      itemsPerPage
    } = usePalmersCategory();

    return {
      isPriceLoaded,
      ...uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      pagination,
      products,
      sortBy,
      cmsContent,
      activeCategoryName,
      routeData,
      doChangeItemsPerPage,
      onReloadProducts,
      goToPage,
      categoryPageContent,
      update,
      term,
      searchResults,
      isInWishlist,
      isAuthenticated,
      itemsPerPage,
      meta: getMetaInfoVuePages({
        title: term.value ? `Search results for: "${term.value}"` : 'Search page'
      })
    }
  },
  head() {
    return this.meta;
  }
});
